import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "opportunity-form",
  class: "salesforce-opportunity-form"
}
const _hoisted_2 = { class: "form-toolbar" }
const _hoisted_3 = { class: "form-cards-container" }
const _hoisted_4 = { class: "card-grid" }
const _hoisted_5 = { class: "field-group" }
const _hoisted_6 = { class: "field-group" }
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-group" }
const _hoisted_11 = { class: "field-group" }
const _hoisted_12 = { class: "card-grid" }
const _hoisted_13 = { class: "field-group field-full" }
const _hoisted_14 = { class: "field-group" }
const _hoisted_15 = { style: {"padding":"5px"} }
const _hoisted_16 = { class: "field-group" }
const _hoisted_17 = { style: {"padding":"10px"} }
const _hoisted_18 = { class: "field-group" }
const _hoisted_19 = { style: {"padding":"10px"} }
const _hoisted_20 = { class: "field-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarForm = _resolveComponent("ToolbarForm")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_FormTextbox = _resolveComponent("FormTextbox")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxValidationGroup = _resolveComponent("DxValidationGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxValidationGroup, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ToolbarForm, {
            "is-editing": _ctx.isEditing,
            onEditCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
            onEditToggled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEdit())),
            onSaveClicked: _ctx.handleSaveClick
          }, null, 8, ["is-editing", "onSaveClicked"])
        ]),
        _createVNode(_component_DxLoadPanel, {
          "show-pane": false,
          width: "auto",
          container: "#opportunity-form",
          position: { of: '#opportunity-form' }
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.general }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSection('general')))
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
              _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Informații Generale", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.general ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "field-label" }, "Nume", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Nume,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.opportunityData.Nume) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.defaultValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "field-label" }, "Prenume", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Prenume,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.opportunityData.Prenume) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.defaultValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "field-label" }, "Funcția", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Titlu,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.opportunityData.Titlu) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.defaultValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "field-label" }, "Partener", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.opportunityData.AccountID,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.opportunityData.AccountID) = $event)),
                  "data-source": _ctx.dsParteneri,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  "read-only": true,
                  opened: _ctx.isParteneriGridBoxOpened,
                  "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isParteneriGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsParteneri,
                      columns: ['Nume'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedPartener
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută partener..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidator, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Compania este obligatorie" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "opened"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "field-label" }, "Metodă de comunicare", -1)),
                _createVNode(_component_DxSelectBox, {
                  items: _ctx.metodaContact,
                  value: _ctx.opportunityData.MetodaContact,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.opportunityData.MetodaContact) = $event)),
                  "read-only": !_ctx.isEditing,
                  placeholder: "Selectează metoda..."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidator, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Metoda de comunicare este obligatorie" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["items", "value", "read-only"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "field-label" }, "Email", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.opportunityData.Email) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.emailValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "field-label" }, "Telefon", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.TelMobil,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.opportunityData.TelMobil) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.phoneValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.general]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.financial }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleSection('financial')))
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Detalii", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.financial ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "field-label" }, "Adresa", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Adresa,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.opportunityData.Adresa) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "field-label" }, "Țară", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.opportunityData.TaraID,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.opportunityData.TaraID) = $event)),
                  "data-source": _ctx.dsTari,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isTaraGridBoxOpened,
                  "onUpdate:opened": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isTaraGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 400, minWidth: 300 }
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_DxDataGrid, {
                        "data-source": _ctx.dsTari,
                        columns: ['Nume'],
                        "hover-state-enabled": true,
                        height: 250,
                        onSelectionChanged: _ctx.onValueSelectedTara
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSelection, { mode: "single" }),
                          _createVNode(_component_DxPaging, {
                            enabled: true,
                            "page-size": 10
                          }),
                          _createVNode(_component_DxFilterRow, { visible: true }),
                          _createVNode(_component_DxSearchPanel, {
                            visible: true,
                            placeholder: "Caută țara..."
                          })
                        ]),
                        _: 1
                      }, 8, ["data-source", "onSelectionChanged"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "field-label" }, "Județ", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.opportunityData.JudetID,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.opportunityData.JudetID) = $event)),
                  "data-source": _ctx.dsJudete,
                  "display-expr": "Nume",
                  "value-expr": "ID",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isJudetGridBoxOpened,
                  "onUpdate:opened": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isJudetGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_DxDataGrid, {
                        "data-source": _ctx.dsJudete,
                        columns: ['Nume'],
                        "hover-state-enabled": true,
                        height: 300,
                        onSelectionChanged: _ctx.onValueSelectedJudet
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSelection, { mode: "single" }),
                          _createVNode(_component_DxPaging, {
                            enabled: true,
                            "page-size": 10
                          }),
                          _createVNode(_component_DxFilterRow, { visible: true }),
                          _createVNode(_component_DxSearchPanel, {
                            visible: true,
                            placeholder: "Caută județ..."
                          })
                        ]),
                        _: 1
                      }, 8, ["data-source", "onSelectionChanged"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "field-label" }, "Localitate", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.opportunityData.LocalitateID,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.opportunityData.LocalitateID) = $event)),
                  "data-source": _ctx.dsLocalitati,
                  "display-expr": "Localitate",
                  "value-expr": "ID",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isLocalitateGridBoxOpened,
                  "onUpdate:opened": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isLocalitateGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_DxDataGrid, {
                        "data-source": _ctx.dsLocalitati,
                        columns: ['Localitate'],
                        "hover-state-enabled": true,
                        height: 300,
                        onSelectionChanged: _ctx.onValueSelectedLocalitate
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxSelection, { mode: "single" }),
                          _createVNode(_component_DxPaging, {
                            enabled: true,
                            "page-size": 10
                          }),
                          _createVNode(_component_DxFilterRow, { visible: true }),
                          _createVNode(_component_DxSearchPanel, {
                            visible: true,
                            placeholder: "Caută localitate..."
                          })
                        ]),
                        _: 1
                      }, 8, ["data-source", "onSelectionChanged"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "field-label" }, "Observații", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.opportunityData.Note,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.opportunityData.Note) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.financial]
            ])
          ], 2)
        ])
      ]),
      _: 1
    })
  ]))
}